import { render, staticRenderFns } from "./NewServerRecord.vue?vue&type=template&id=08e70e6d&scoped=true&"
import script from "./NewServerRecord.vue?vue&type=script&lang=js&"
export * from "./NewServerRecord.vue?vue&type=script&lang=js&"
import style0 from "./NewServerRecord.vue?vue&type=style&index=0&id=08e70e6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e70e6d",
  null
  
)

export default component.exports